const stepsV3 = [
  {
    id: 1,
    title: 'Cadastre seus dados',
    description:
      'Informe seus dados pessoais para dar início ao pedido de financiamento.',
    url: null,
    srcImage: '/assets/images/carousel-default.png',
  },
  {
    id: 2,
    title: 'Cadastre sua pessoa avalista',
    description: 'Escolha uma pessoa para estar junto com você nessa jornada.',
    url: null,
    srcImage: '/assets/images/Ilustra-user.png',
  },
  {
    id: 3,
    title: 'Aguarde a análise de crédito',
    description: 'O resultado de sua análise de crédito sairá em até 7 dias',
    url: null,
    srcImage: '/assets/images/ilustra-ampulheta.png',
  },
  {
    id: 4,
    title: 'Assine o documento',
    description:
      'Com o financiamento aprovado, te enviaremos o documento de contratação.',
    url: null,
    srcImage: '/assets/images/carousel-default-dois.png',
  },
];

export default stepsV3;
